import { render } from "./ExampleDeviceScreenPaypal.vue?vue&type=template&id=077694e7&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenPaypal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenPaypal.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenPaypal.vue?vue&type=style&index=0&id=077694e7&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077694e7"]])

export default __exports__